<template>
  <footer class="cesco-footer">
    <div>
      <div class="sec-1">
        <p v-if="!mobileCheck">
          CESCO Co., Ltd. (Chairman: Jeon Chan-hyuk)<br />
          05288, CESCO Touch Center, 46, Sangil-ro 10-gil, Gangdong-gu, Seoul, South Korea
          <span>FAX: +82.2.488.1720</span> <span>TEL: +82.2.1588.1119</span><br />
          Business registration number: 212-81-05946 <span>Mail order business report number: 2008-Seoul Gangdong-0240</span>
        </p>
        <p v-else>
          CESCO Co., Ltd. (Chairman: Jeon Chan-hyuk)<br />
          05288, CESCO Touch Center,<br />
          46, Sangil-ro 10-gil, Gangdong-gu,<br />
          Seoul, South Korea<br />
          FAX: +82.2.488.1720 <span>TEL: +82.2.1588.1119</span><br />
          Business registration number: <br />
          212-81-05946 <br />
          Mail order business report number:<br />
          2008-Seoul Gangdong-0240
        </p>

        <p>Copyright © CESCO All Rights reserved</p>
      </div>
      <div class="sec-2">
        <div class="social-box">
          <a href="https://www.facebook.com/cescokr" target="_blank">
            <img src="@/assets/images/icons/jt-facebook.svg" class="size-12" />
          </a>
          <a href="https://blog.naver.com/cescomembers" target="_blank">
            <img src="@/assets/images/icons/jt-naver blog.svg" class="size-12" />
          </a>
          <a href="https://www.instagram.com/cesco_kr/" target="_blank">
            <img src="@/assets/images/icons/jt-instagram.svg" class="size-12" />
          </a>
          <a href="https://www.youtube.com/user/CESCOmembers" target="_blank">
            <img src="@/assets/images/icons/jt-youtube.svg" class="size-12" />
          </a>
        </div>
        <div class="me-small-dropdown">
          <div :class="{ open: isActive }" @click="isActive = !isActive">
            <span class="text">Family site</span>
            <img src="@/assets/images/icons/Down.svg" />
          </div>
          <div class="dropdown">
            <ul>
              <li>
                <a href="https://www.cescomall.co.kr/newmain" target="_blank">CESCO Mall (KR)</a>
              </li>
              <li>
                <a href="https://www.cescoacademy.co.kr/" target="_blank">CESCO Academi (KR)</a>
              </li>
              <li>
                <a href="https://www.cescolifecare.co.kr/" target="_blank">CESCO Lifecare (KR)</a>
              </li>
              <li>
                <a href="https://smartstore.naver.com/cescomall" target="_blank">CESCO Smart Store (KR)</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, inject } from 'vue'

const mobileCheck = inject('mobileCheck')
const isActive = ref(false)
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/footer.scss';
</style>
